export default __webpack_public_path__ + "static/media/rnb-fb.7fd2e1dd.webp";